var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_624_3057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2222 26.831C29.8516 25.975 29.4258 25.0462 28.4444 25.0462H27.5556C28.5369 25.0462 29.3333 24.247 29.3333 23.2613V8.08616C29.3333 7.10038 28.5369 6.30127 27.5556 6.30127H4.44444C3.46311 6.30127 2.66667 7.10038 2.66667 8.08616V23.2613C2.66667 24.247 3.46311 25.0462 4.44444 25.0462H3.55556C2.57422 25.0462 2.07378 25.9386 1.77778 26.831L0 31.1822C0 32.1688 0.796444 32.9679 1.77778 32.9679H30.2222C31.2036 32.9679 32 32.1688 32 31.183L30.2222 26.831Z",
    fill: "#CCD6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0078125 31.2568L0.0131458 31.3075L0.164257 31.9226C0.445146 32.5377 1.06026 32.9679 1.77848 32.9679H30.2229C31.1794 32.9679 31.9536 32.2079 31.9936 31.2568H0.0078125Z",
    fill: "#9AAAB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5564 22.3678C27.5564 22.8611 27.1591 23.2602 26.6675 23.2602H5.3342C4.84353 23.2602 4.44531 22.8611 4.44531 22.3678V8.97936C4.44531 8.48602 4.84353 8.08691 5.3342 8.08691H26.6675C27.1591 8.08691 27.5564 8.48691 27.5564 8.97936V22.3678Z",
    fill: "#5DADEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2479 28.5606L28.5724 26.6273C28.3599 26.2184 28.0079 25.8833 27.5164 25.8833H4.54037C4.0497 25.8833 3.73503 26.246 3.51281 26.8042L2.90125 28.5615C2.70659 29.0913 3.29948 29.454 3.79014 29.454H10.5261C10.5261 29.454 11.359 29.4122 11.5066 28.9135C11.6773 28.3375 11.8755 27.47 11.9181 27.3171C11.9839 27.0824 12.263 26.8451 12.679 26.8451H20.3039C20.7484 26.8451 20.967 27.07 21.0248 27.3482C21.0621 27.5295 21.3021 28.3624 21.4141 28.9322C21.5128 29.4397 22.4995 29.4531 22.4995 29.4531H28.3608C28.8506 29.4531 29.4426 29.0344 29.2479 28.5606Z",
    fill: "#AEBBC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8908 30.4014H12.9743C12.641 30.4014 12.4961 30.0965 12.5441 29.8014C12.5921 29.5071 12.8632 28.2076 12.8846 28.0565C12.905 27.9045 13.1281 27.7231 13.3503 27.7231H19.5859C19.8499 27.7231 20.0215 27.868 20.0748 28.1578C20.1272 28.4485 20.3432 29.6165 20.3601 29.8831C20.377 30.1507 20.2099 30.4014 19.8908 30.4014Z",
    fill: "#9AAAB4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_624_3057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.967773)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalComputer);
export default __webpack_public_path__ + "static/media/personal-computer.cefaa54b504e02c4492c15a5b1fdb072.svg";
export { ForwardRef as ReactComponent };